import autoload from "./autoload";
import auth from "./mixins/auth";
import cart from "./mixins/cart";
import initDom from "./mixins/init_dom";

autoload();

window.app = new Vue({
  el: "#vue-cerakote-vs",

  mixins: [initDom, auth, cart],

  data() {
    return {
      playCerakoteVsPVD: false,
      playCerakoteVsBluing: false,
      playCerakoteVsSaltChamber: false,
      playCerakoteVsNitride: false,
      goTo: window._PR?.goTo || "",
    };
  },

  mounted() {
    let vm = this;

    if (vm.goTo.length) {
      setTimeout(function () {
        vm.scrollTo("#".concat(vm.goTo));
      }, 300);
    }

    $(window).on("resize load", function () {
      $(window).scroll(function () {
        if ($(window).scrollTop() >= 500) {
          $(".back-to-top").css("display", "inline");
        } else {
          $(".back-to-top").css("display", "none");
        }
      });
    });
  }
});
